import styled from 'styled-components';

import BgPremium from 'assets/images/bg_premium.png';

export const Container = styled.div`
  height: 100%;

  background: linear-gradient(
    180deg,
    rgba(160, 227, 235, 0.5) 2.65%,

    rgba(255, 255, 255, 0.5) 104.06%
  );

  .bg-premium {
    background: url('${BgPremium}') #d5f3f6 top center no-repeat;

    background-size: auto;
  }

  h1 {
    font-weight: 700;
    font-size: 36px;
    color: #000000;
  }

  h2 {
    font-weight: 500;
    font-size: 26px;
    line-height: 36px;
    color: #20233c;
  }

  .button-comprar {
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    color: #ffffff;
    height: 58px;
    background: linear-gradient(180deg, #6cd8b4 0%, #3ba884 100%);
    border: 6px solid rgba(0, 0, 0, 0.8);
    border-radius: 50px;
  }

  h3 {
    font-weight: 700;
  }

  .card-text {
    font-weight: 300;
    font-size: 16px;
    color: #000000;
  }

  .p-separador {
    font-weight: 700;
    font-size: 32px;
    color: #000000;
    margin-top: 130px;
  }

  .title {
    font-weight: 700;
    font-size: 36px;
    color: #000000;
  }

  .subTitle {
    font-weight: 400;
    font-size: 22px;
  }

  .mercado-licitacao {
    font-weight: 700;
    font-size: 36px;
    color: #20233c;
  }

  .card-title {
    font-weight: 700;
    font-size: 18px;
    color: #20233c;
  }

  .card-subtitle {
    font-weight: 400;
    font-size: 16px;
    color: #20233c;
  }

  .title-number {
    font-weight: 700;
    font-size: 42px;
    color: #20233c;
  }

  .margin {
    margin-bottom: 150px;
  }

  .bg-plano {
    background-color: #e8f3f4;
  }

  .acesso {
    font-weight: 300;
    font-size: 20px;
  }

  li {
    font-size: 18px;
    font-weight: 400;
  }

  .card-header {
    background-color: #fff;
  }

  .valor {
    font-weight: 400;
    font-size: 32px;
  }

  .button {
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    color: #ffffff;
    padding: 10px;
    background: linear-gradient(180deg, #6cd8b4 0%, #3ba884 100%);
    border: 3px solid rgba(0, 0, 0, 0.8);
    border-radius: 50px;
  }

  .btn-link {
    color: #20233c;
    font-size: 18px;
  }

  .badge-success {
    background-color: #3ba884 !important;
    font-size: 30px;
  }

  .resultados {
    background-color: #20233c;
    color: #ffffff;
  }
`;
